"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_js_1 = __importDefault(require("@hh.ru/analytics-js"));
/** По клику открывается отдельная страница с картой, где отмечен адрес вакансии */
const addressMapButtonClick = ({ vacancyId, ...analyticsParams }) => analytics_js_1.default.sendHHEventButtonClick("address_map", { vacancyId, ...analyticsParams });
exports.default = addressMapButtonClick;
